import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  icon: {
    height: "6vmax",
    width: "6vmax",
    alignSelf: "center",
    tintColor: "$image_unselected",
  },
  iconSelected: {
    tintColor: "$image_selected",
  },
  label: {
    fontWeight: "bold",
    textAlign: "center",
    fontSize: "$icon_lable_size",
    fontFamily: "$icon_lable_style",
    color: "$option_text",
  },
  labelSelected: {
    color: "$selected_option",
  },
  container: {
    margin: "0.1vmin",
    justifyContent: "center",
    alignItems: "center",
    padding: 10,
  },
});
